import { css } from '@emotion/core';
import { tokens, getCssVariableValue } from '@domain-group/fe-brary';
export var colours = () => [getCssVariableValue(tokens.colors.interactive.base.default), getCssVariableValue(tokens.colors.accentTwo.base.default)];
export var legend = {
  name: "1qm1lh",
  styles: "margin-bottom:16px;"
};